<template>
  <div>
    <div class="anime_title_main">
      <popup-info :showPopup="showPopup" @update="hidePopup" >{{ popup_text }}</popup-info>
        <div class="main_center">
          <div class="wrapper_poster_info">
            <div class="poster" :style="{backgroundImage: 'url(' + poster + ')', 'background-size': 'cover', 'background-position-x': '50%'}">
              <!-- <img :src="poster" alt="Anime Poster" /> -->
              <div class="wrapper_season_episode" v-show="show_player_season_episode">
                <div class="season_episode"><span>Сезон: {{ current_player_episode.season }}</span><span>Серия: {{ current_player_episode.episode }}</span></div>
                <div class="voiceover"><span>{{ current_player_voiceover }}</span></div>
              </div>
              <div class="state_of_anime">
                <select v-model="selected" @change="changeSelectStateOfAnimeList()" name="select">
                  <option disabled value="notSelected">Добавить в список</option>
                  <option value="watching">Смотрю</option>
                  <option value="watched">Просмотрено</option>
                  <option value="planned">Запланировано</option>
                  <option value="postponed">Отложено</option>
                  <option value="droped">Брошено</option>
                  <option value="delete">Удалить из списка</option>
              </select>
              <button class="favorite_button"  @click="changeFavorite()"><img style="width: 20px;margin-top: 4px;" src="@/assets/icons/favorite.svg"></button>
              </div>
            </div>
            <div class="bg_image" :style="{ backgroundImage: 'url(' + bgImage + ')', 'background-repeat': 'no-repeat', 'background-size': 'cover', 'background-position-x': '50%'}"></div>
            <div class="bg_black"></div>
            <div class="info">
              <h1 class="title" style="font-family: 'Montserrat';">{{ title }}</h1>
              <p class="title_original">
                <span style="font-weight: bold; color: grey">{{ title_original }}</span>
                <span class="link_span_mpaa">
                   {{ rating_mpaa ? (rating_mpaa.toUpperCase() === 'PG13' ? 'PG-13' : rating_mpaa.toUpperCase()) : '' }}
                </span>
              </p>

              <p class="score">
                <span class="shikimori_score" title="Рейтинг по данным Шикимори" style="background: #3e3e3e; margin-right: 10px; border-radius: 5px;padding: 3px 8px;font-weight: bold;">
                  <a :href="getShikimoriLink()" target="_blank"><img style="width: 14px;transform: translate(0, 1px);" src="@/assets/icons/shikimori_icon.svg"></a>  {{ score }}
                </span>
                <span v-if="scoreImdb" style="background: #F5C518; color: black; border-radius: 5px;padding: 3px 8px;font-weight: bold;">
                  <a :href="getImdbLink()" style="color: black;" target="_blank">IMDb</a> <span style="font-weight: bold;">{{ scoreImdb }}</span> 
                </span>
              </p>
              <p class="genre">
                <span class="bold">Жанр:  </span>
                  <span class="anime_genre link_span" v-for="genre in anime_genres" :key="genre">
                    <router-link  :to="'/genre/' + genre">
                      {{ genre }} 
                    </router-link>
                  </span>
              </p>
              <span class="bold">Статус: <span :class="status === 'Выходит' ? 'blue' : (status === 'Анонс' ? 'red' : 'green')" style="color: white; font-weight: normal;">{{ status }}</span></span>
              <p class="date"><span class="bold">Дата выхода:</span> {{ reverseDate(aired_on) }}</p>
              <!-- <p class="date"><span class="bold">Дата выхода:</span> {{ aired_on }}</p> -->
              <p class="episodes"><span class="bold">Кол-во cерий:</span> {{ (status == 'Вышел' ? episodes : episodes_aired) + ' из ' + episodes}}</p>
              
              <!-- <p class="studios">
                <span class="bold">Студия: </span> 
                <span class="link_span" v-for="studio in studios" :key="studio">
                  <router-link :to="'/studio/' + studio">
                    <span >{{ studio }}</span>
                  </router-link>
                </span>
              </p> -->
              <span-block-swiper :content="studios || []" :title="'Студия'" :wrapper_class="'overflow-wrapper0'" :page_path="'studio'"></span-block-swiper>
              <span-block-swiper :content="writers || []" :title="'Авторы'" :wrapper_class="'overflow-wrapper'" :page_path="'writer'"></span-block-swiper>
              <span-block-swiper :content="directors" :title="'Режиссеры'" :wrapper_class="'overflow-wrapper1'" :page_path="'director'"></span-block-swiper>
              <p class="description truncate" @click="truncate" v-html="description"></p>
            </div>
          </div>
          
          <div class="wrapper_kodik_player">
          	<iframe id="kodik_player" :src="'//kodik.cc/find-player?shikimoriID=' + id" width="610px" height="370px" frameborder="0" allowfullscreen allow="autoplay *; fullscreen *"></iframe>
          </div>	
          <!-- Yandex.RTB R-A-3979874-2 -->
          <div id="yandex_rtb_R-A-3979874-2" style="margin-top: 30px;"></div>
        </div>
    </div>
    
    <related-anime :anime_id="id" :key="id"></related-anime>
    <similar-anime :anime_id="id" :key="id+1"></similar-anime>
    <canvas id="cnvs"></canvas>
    
  </div>
</template>

<script>
import axios from "axios";
import SimilarAnime from '@/widgets/SimilarAnime.vue';
import RelatedAnime from '@/widgets/RelatedAnime.vue';
import SpanBlocksSwiper from '@/widgets/SpanBlocksSwiper.vue';
import EpisodeHint from '@/widgets/EpisodeHint.vue';
import PopupInfo from "@/shared/ui/PopupInfo.vue";



export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      poster: "",
      title: "",
      title_original: "",
      rating_mpaa: "",
      score: "",
      scoreImdb: "",
      anime_genres: [],
      aired_on: "",
      status: "",
      episodes_aired: "",
      episodes: "",
      studios: [],
      writers: [],
      directors: [],
      isExpanded: false,
      description: "",
      bgImage: "",
      selected: "notSelected",
      favoriteSelected: 0,
      showPopup: false,
      popup_text: '',
      current_player_episode: '',
      current_player_voiceover: '',
      show_player_season_episode: false,
      imdb_id: ''
    };
  },
  components: {
    'similar-anime': SimilarAnime,
    'related-anime': RelatedAnime,
    'span-block-swiper': SpanBlocksSwiper,
    'episode-hint': EpisodeHint,
    'popup-info': PopupInfo
  },
  mounted() {
    let that = this;
    let prevEpsodeData = ''
    function kodikMessageListener(message) {
          if (message.data.key == 'kodik_player_current_episode') {
            console.log("FuCK ShiT");
            if(JSON.stringify(prevEpsodeData) != JSON.stringify(message.data.value)){
              that.updateSeasonEpisode(JSON.stringify(message.data.value));
              console.log(that.current_player_episode);
              prevEpsodeData = message.data.value
            }
          }
        }

    if (window.addEventListener) {
      console.log("kodikMessageListener");
      window.addEventListener('message', kodikMessageListener);
    } else {
      console.log("kodikMessageListener");
      window.attachEvent('onmessage', kodikMessageListener);
    }


    window.scrollTo(0,0);
    axios
      .get(`https://kodikapi.com/search?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&shikimori_id=${this.id}`)
      .then(response => {
        if(response.data.results.length == 0){
          window.location.pathname = '/not_found';
        }
        // console.log(response.data.results.length);
        this.setDataFromApi(response);
        this.setHeadTitle(this.title);
        this.setHeadDescription(this.description);
        
        
        this.yaMetrica();
        if(localStorage.getItem("logging") !== 'disable'){
          this.getFingerprint();
        }

        
        console.log(response);
      })
      .catch(error => {
        console.log(error);
      });

      this.getStateOfAnime(window.location.pathname.replace('/',''));
      document.onmousedown = function(e) {
        if(e.target.className === 'website_name_span'){
          console.log(1);
          localStorage.setItem('scrollY', 0);
        }
        // localStorage.setItem('logging', 'disable');
      } 

      if(localStorage.getItem('username')){
        if(document.querySelector('.cabinet span')){
          document.querySelector('.cabinet span').remove();
        }
        document.querySelector('.cabinet').insertAdjacentHTML('afterbegin', `<span class="username_header" style="margin-right: 20px;">${localStorage.getItem('username')}</span>`);
      }


      window.yaContextCb.push(()=>{
        Ya.Context.AdvManager.render({
          "blockId": "R-A-3979874-2",
          "renderTo": "yandex_rtb_R-A-3979874-2"
        })
      })

      console.log('MOUNTED');
      
  },
  watch:{
    favoriteSelected(newFav, oldFav){
      if(this.favoriteSelected == 1){
        document.querySelector(".favorite_button").style.backgroundColor = '#ffb100';
        console.log(1);
        this.popup_text = 'Добавлено в список "Избранное"';
      }else if(this.favoriteSelected == 0){
        this.popup_text = 'Удалено из списка "Избранное"';
        document.querySelector(".favorite_button").style.backgroundColor = 'white';
      }
    },
    $route(to, from) {
      window.scrollTo(0,0);
      console.log('BACK');
      axios
      .get(`https://kodikapi.com/search?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&shikimori_id=${this.id}`)
      .then(response => {
        this.setDataFromApi(response);
        this.setHeadTitle(this.title);
        this.setHeadDescription(this.description);
        this.getStateOfAnime(this.id);
        
        this.yaMetrica();
        if(localStorage.getItem("logging") !== 'disable'){
          this.getFingerprint();
        }
        console.log(response);
      })
      .catch(error => {
        console.log(error);
      });

    }
  },
  methods: {
    hidePopup(val){
      this.showPopup = val;
    },
    changeFavorite: function(){
        this.favoriteSelected = this.favoriteSelected == 1 ? 0 : 1;
        this.writeDBSelectedStateOfList(this.selected, this.favoriteSelected);
    },
    changeSelectStateOfAnimeList: function(){
      console.log(this.selected);
      this.popup_text = 'Добавлено в список "' + this.getRuSelected(this.selected) + '"';
      // this.showPopup = true;
      if(this.selected === "deleted"){
        this.selected = "deleted";
        this.writeDBSelectedStateOfList("deleted", 0);
      }
      this.writeDBSelectedStateOfList(this.selected, this.favoriteSelected);
    },
    setDataFromApi: function(response){
      this.poster = response.data.results[0].material_data.poster_url ? response.data.results[0].material_data.poster_url.replace('.me/', '.one/') : 'https://anione.fun/404_not_found.png';
      this.getScreenshotes();
      this.title = response.data.results[0].title;
      this.title_original = response.data.results[0].title_orig;
      this.rating_mpaa = response.data.results[0].material_data.rating_mpaa;
      this.score = response.data.results[0].material_data.shikimori_rating;
      this.scoreImdb = response.data.results[0].material_data.imdb_rating;
      this.anime_genres = response.data.results[0].material_data.anime_genres || [];
      this.aired_on = response.data.results[0].material_data.aired_at || "";
      // this.aired_on = response.data.results[0].created_at || "";
      this.status = this.getRuStatus(response.data.results[0].material_data.anime_status);
      this.episodes_aired = response.data.results[0].material_data.episodes_aired;
      this.episodes = response.data.results[0].material_data.episodes_total == 0 ? '?' : response.data.results[0].material_data.episodes_total;
      this.studios = response.data.results[0].material_data.anime_studios;
      this.writers = response.data.results[0].material_data.writers;
      this.directors = response.data.results[0].material_data.directors;
      this.description = response.data.results[0].material_data.description;
      this.kind = this.getRuKind(response.data.results[0].material_data.anime_kind);
      this.imdb_id = response.data.results[0].imdb_id;
    },
    getShikimoriLink: function(){
      return `https://shikimori.one/animes/${window.location.pathname.replace('/','')}`
    },
    getImdbLink: function(){
      return `https://www.imdb.com/title/${this.imdb_id}`
    },
    getScreenshotes: function(){
    	axios
	      .get(`https://shikimori.one/api/animes/${this.id}`)
	      .then(response => {
	        this.bgImage = response.data.screenshots.toString() === '' ? "" : 'https://shikimori.one' + response.data.screenshots[1].original;
          console.log(this.bgImage);
        })
	      .catch(error => {
	        console.log(error);
	      });
    },
    getRuSelected(option){
      switch (option) {
        case 'watching':
          return 'Cмотрю';
        case 'watched':
          return 'Просмотренно';
        case 'planned':
          return 'Запланированно';
        case 'postponed':
          return 'Отложено';
        case 'droped':
          return 'Брошено';
        default:
          return option;
      }
    },
    getRuStatus: function(status){
      switch (status) {
        case 'released':
          return 'Вышел';
        case 'ongoing':
          return 'Выходит';
        case 'anons':
          return 'Анонс';
        default:
          return status;
      }
    },
    getRuKind: function(kind){
      switch (kind) {
        case 'tv':
          return 'Сериал';
        case 'movie':
          return 'Фильм';
        case 'special':
          return 'Спэшл';
        default:
          return kind;
      }
    },
    reverseDate: function(dateStr) {
      if(dateStr === ''){
        return 'Неизвестно';
      }
      var parts = dateStr.split("-");
      var reversedDate = parts[2] + "." + parts[1] + "." + parts[0];
      return reversedDate;
    },
    truncate: function() {
      var p = document.querySelector("p.truncate");
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        p.style.display = 'block';
      } else {
        p.style.display = '-webkit-box';
      }
    },
    setHeadTitle: function(title) {
      document.querySelector('head title').textContent = title;
    },
    setHeadDescription: function(description){
      document.querySelectorAll('head meta')[3].setAttribute("content", description)
    },
    updateSeasonEpisode: function(season_episode){
      if(localStorage.getItem('password_hash') && localStorage.getItem('user_id')){
        if(this.selected === 'watching'){
          
          console.log('IF WATHING --> THEN UPDATE EPISODE IN DB')
          let url = `${window.location.protocol}//${window.location.hostname}/api/insertStateOfList.php?user_id=${localStorage.getItem('user_id')}&password_hash=${localStorage.getItem('password_hash')}&shikimori_id=${window.location.pathname.replace('/','')}&state_of_anime=${this.selected}&season_episode=${season_episode}`;
          console.log(url)
          axios
          .get(url)
          .then((response) => {
            if(response.status == 200){
              console.log("LOL" + response.data);
              this.getStateOfAnime(window.location.pathname.replace('/',''));
            }
          })
          .catch((error) => {
            this.popup_text = 'Ошибка обновления сезонов и серий';
            this.showPopup = true;
            console.error(error);
          });
        }
      }
    },
    writeDBSelectedStateOfList: function(selected, favoriteSelected){
      this.isAuthenticated(selected, favoriteSelected);
    },
    isAuthenticated: function(selected, favoriteSelected){
      if(localStorage.getItem('password_hash') && localStorage.getItem('user_id')){
        let url = `${window.location.protocol}//${window.location.hostname}/api/insertStateOfList.php?user_id=${localStorage.getItem('user_id')}&password_hash=${localStorage.getItem('password_hash')}&shikimori_id=${window.location.pathname.replace('/','')}&is_favorite=${favoriteSelected}&state_of_anime=${selected}&title=${this.title}&poster_anime=${this.poster}&score=${this.score}&status=${this.status}&kind=${this.kind}&season_episode=${this.current_player_episode}`;
        console.log(url)
        axios
        .get(url)
        .then((response) => {
          console.log(response);
          if(response.status == 200){
            this.showPopup = true;
          }
          if(selected === 'delete'){
            window.location.reload();
          }
        })
        .catch((error) => {
          this.popup_text = 'Ошибка добавления';
          this.showPopup = true;
          console.error(error);
        });
      }else{
        window.location.pathname = '/auth';
      }
    },
    getFingerprint: function(){
      getFingerprintGlobal(this.title, this.poster);
    },
    getStateOfAnime: function(shikimori_id){
      if(localStorage.getItem('password_hash') && localStorage.getItem('user_id')){
        let url = `${window.location.protocol}//${window.location.hostname}/api/getStateOfAnime.php?password_hash=${localStorage.getItem('password_hash')}&user_id=${localStorage.getItem('user_id')}&shikimori_id=${shikimori_id}`;
        axios
        .get(url)
        .then((response) => {
          if(response.data){
            this.selected = response.data[0].state_of_anime ? response.data[0].state_of_anime : 'notSelected';
            this.favoriteSelected = response.data[0].is_favorite ? response.data[0].is_favorite : 0;
            let current_player_episode = response.data[0].season_episode ? response.data[0].season_episode : 0;
            this.current_player_episode = JSON.parse(current_player_episode);
            this.current_player_voiceover = JSON.parse(current_player_episode).translation.title;
            if(this.current_player_episode.season && this.current_player_episode.episode){
              this.show_player_season_episode = true;
            }
          }else{
            this.selected = 'notSelected';
            this.favoriteSelected = 0;
            console.log('getStateOfAnime => response.data: ' + response.data);
          }
        })
        .catch((error) => {
          console.error(error);
        });
      }
    },
    isMobileFunc: function() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
         return true
      } else {
         return false
      }
    },
    yaMetrica: function(){
      (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
      m[i].l=1*new Date();
      for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
      k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
      (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(92835246, "init", {
            clickmap:true,
            trackLinks:true,
            accurateTrackBounce:true
      });
    }
  }
};
</script>

<style scoped>
.state_of_anime select,.state_of_anime option, .favorite_button{
  cursor: pointer;
}

.state_of_anime option{
  padding: 10px;
}

.anime_title_main{
  margin: 0 150px;
  font-family: 'Exo 2', sans-serif;
}

.bold{
  font-weight: bold;
  color: grey;
}

#cnvs{
  width: 1px;
  height: 1px;
}


.bg_image{
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  box-shadow: 0px -55px 103px 24px rgb(0 0 0) inset;
}


.bg_black{
  background-color: #00060ed9;
/*  backdrop-filter: blur(5px);*/
  position: absolute;
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 2;
}



.main_center{
  margin: 13px 20px 20px 20px;
}

.wrapper_poster_info{
  display: flex;
}

.poster {
  position: relative;
  min-width: 300px;
  max-width: 300px;
  width: 100%;
  height: 420px;
  margin-right: 35px;
  border-radius: 8px;
  z-index: 5;
}




.link_span{
  display: inline-block; 
  border: 1px solid #5555555e;
  border-radius: 5px; 
  background: #2a2a2a99;
  color:white; 
  padding: 0 6px;
  margin: 2px 6px 4px 0;
}

.info .episodes{
  margin-bottom: 3px;
}

.anime_genre a:hover{
  color: #248aff !important;
}

.anime_genre a{
  transition: .4s;
}

.studios a:hover{
  color: #248aff !important;
}

.studios a{
  transition: .4s;
}

/*STATE OF ANIME*/
.state_of_anime{
  display: flex;
  position: absolute;
  width: 100%;
  bottom: 0;
}

.state_of_anime select{
  width: 100%;
  margin: 0 0;
  padding: 10px 7px;
  border: none;
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  font-family: 'Montserrat', sans-serif;
  outline: none;
}

.state_of_anime option{
  padding: 10px 10px;
  border-radius: 5px;
}

.state_of_anime .favorite_button{
  width: 44px;
  background-color: white;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: none;
  border-top: none;
  border-bottom: none;
  border-left: 2px solid #d9d9d9;
}


/*INFO*/
.info{
  position: relative;
  z-index: 5;
}

.title {
  font-size: 1.5rem;
  margin: 0;
  text-align: left;
  font-family: 'Exo 2', sans-serif;
/*  font-family: 'Montserrat', sans-serif;
  font-weight: 800;*/
}

.status .status_span{
  background-color: #0d6efd;
  padding: 1px 5px;
  border-radius: 4px;
}

.description {
  font-size: 1.1rem;
  line-height: 1.5;
  cursor: pointer;
}

p.truncate {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
}

.title_original{
  margin: 0;
}
/*For modile devices*/

.blue{
  background-color: #0d6efd;
  padding: 3px 5px;
  border-radius: 4px;
}

.red{
  background-color: red;
  padding: 3px 5px;
  border-radius: 4px;
}

.green{
  background-color: green;
  padding: 3px 5px;
  border-radius: 4px;
}


#yohoho{
  height: 600px;
  z-index: 10;
}

#yohoho-iframe{
  height: 600px;
}



.wrapper_kodik_player {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 25px;
    height: 0;
    margin-top: 20px;
}

.wrapper_kodik_player #kodik_player {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 7px;
    z-index: 10;
}


.share_button{
	display: none !important;
}

.fp-timeline{
	border-radius: 5px;
}

.link_span_mpaa{
  display: inline-block;
  border: 1px solid #5555555e;
  border-radius: 5px;
  color: white;
  padding: 0 6px;
  margin: 2px 6px 4px 5px;
  font-weight: bold;
  font-size: 13px;
}

.wrapper_season_episode{
  padding: 10px;
}

.wrapper_season_episode .season_episode span{
  background: #7ac75d;
  padding: 3px 7px;
  border-radius: 5px;
  font-weight: bold;
  margin-right: 10px;
}

.wrapper_season_episode .voiceover{
  padding-top: 10px;
}

.wrapper_season_episode .voiceover span{
  background: #6495ff;
  padding: 3px 7px;
  border-radius: 5px;
  font-weight: bold;
  margin-right: 10px;
}

@media only screen and (max-width: 992px) {
	.anime_title_main{
		margin:0;
	}
}

@media only screen and (max-width: 768px) {
  .bg_black{
    background-color: #000000c7;
  }

  .main_center {
    margin: 10px 20px 20px 20px;
  }

  .anime_title_main{
    display: flex;
    justify-content: center;
    margin:0;
  }

  .wrapper_poster_info{
    display: block;
  }


  .poster{
    display: flex;
    min-width: 280px;
    max-width: 280px;
    height: 390px;
    justify-content: center;
    float: none;
    margin: 0 auto;
  }

  
  
  .state_of_anime{
    left: 50%;
    transform: translate(-50%, 0);
  }

  .info{
    margin-top: 30px;
  }

  .main_center{
    width: 100%;
  }
}
</style>